import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';
import TestimonialCard from '../components/TestimonialCard';
import SEO from '../components/SEO';

const Testimonials = () => {
  return (
    <div className="testimonials-page">
      <SEO 
        title="Customer Reviews & Testimonials | SBF Home Improvements | Fayette County, PA"
        description="Read reviews from satisfied customers in Fayette County. 5-star rated home improvement contractor. See what our clients say about our roofing, siding, deck & flooring work."
        keywords="customer reviews, testimonials, contractor reviews, Fayette County reviews, home improvement ratings, SBF reviews, 5 star contractor"
      />
      {/* Hero Section */}
      <section style={{background: 'var(--bg-page)', padding: '120px 40px 80px'}}>
        <div className="container" style={{textAlign: 'center'}}>
          <h1 className="heading-1" style={{color: 'var(--text-primary)', marginBottom: '24px'}}>CLIENT TESTIMONIALS</h1>
          <p className="body-large" style={{color: 'var(--text-secondary)', maxWidth: '60ch', margin: '0 auto 32px'}}>Don't just take our word for it—hear from our satisfied customers</p>
          <div style={{display: 'flex', justifyContent: 'center', gap: '4px'}}>
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={32} fill="var(--brand-primary)" color="var(--brand-primary)" />
            ))}
          </div>
          <p className="body-medium" style={{color: 'var(--text-primary)', marginTop: '16px'}}>5.0 Average Rating</p>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section style={{background: 'var(--bg-card)', padding: '96px 40px'}}>
        <div className="container">
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '32px'}}>
            {testimonials.map((testimonial) => (
              <TestimonialCard key={testimonial.id} testimonial={testimonial} />
            ))}
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section style={{background: 'var(--bg-page)', padding: '96px 40px'}}>
        <div className="container" style={{maxWidth: '800px', textAlign: 'center'}}>
          <Quote size={48} color="var(--brand-primary)" style={{margin: '0 auto 32px'}} />
          <p className="body-large" style={{color: 'var(--text-primary)', lineHeight: '1.6', marginBottom: '24px', fontStyle: 'italic'}}>
            "The professionalism and quality of work from SBF Home Improvements has earned them a customer for life. Every interaction has been positive, and the results speak for themselves."
          </p>
          <div style={{marginTop: '32px'}}>
            <p className="heading-5" style={{color: 'var(--text-primary)'}}>Robert Williams</p>
            <p className="body-small" style={{color: 'var(--text-secondary)'}}>Homeowner, Pittsburgh PA</p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{background: 'var(--bg-card)', padding: '80px 40px'}}>
        <div className="container">
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '40px', textAlign: 'center'}}>
            <div>
              <div className="heading-1" style={{color: 'var(--brand-primary)', marginBottom: '8px'}}>500+</div>
              <p className="body-medium" style={{color: 'var(--text-secondary)'}}>Happy Customers</p>
            </div>
            <div>
              <div className="heading-1" style={{color: 'var(--brand-primary)', marginBottom: '8px'}}>98%</div>
              <p className="body-medium" style={{color: 'var(--text-secondary)'}}>Satisfaction Rate</p>
            </div>
            <div>
              <div className="heading-1" style={{color: 'var(--brand-primary)', marginBottom: '8px'}}>5.0</div>
              <p className="body-medium" style={{color: 'var(--text-secondary)'}}>Average Rating</p>
            </div>
            <div>
              <div className="heading-1" style={{color: 'var(--brand-primary)', marginBottom: '8px'}}>15+</div>
              <p className="body-medium" style={{color: 'var(--text-secondary)'}}>Years in Business</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;